<template>
  <li class="nav_sub_item">
    <app-link v-if="url" v-bind:link="this.subitem" v-bind:homeUrl="homeUrl" v-bind:description="description" class="nav_sub_link"/>
    <span v-if="!url && name" class="nav_sub_title">{{name}}</span>
    <ul class="nav_sub_sub">
      <navigation-sub v-for="subitem in links" :key="subitem.name" v-bind:subitem="subitem" v-bind:homeUrl="homeUrl"/>
    </ul>
  </li>
</template>

<script>
  import NavigationSub from './NavigationSub'
  import AppLink from './AppLink'

  export default {
    name: 'NavigationSub',
    components: {
      AppLink,
      NavigationSub
    },
    props: ['subitem', 'homeUrl'],
    data () {
      return {
        name: this.subitem.name,
        links: this.subitem.links,
        url: this.subitem.url,
        description: this.subitem.description
      }
    }
  }
</script>



// WEBPACK FOOTER //
// NavigationSub.vue?3b74a3e1